import React, { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import "../css/toolMenu.css";
import close from "../images/close.png";
import { Common } from "./Canvas";
import {
  getSizeAndPath,
  getSizesSelected,
  glitterShadowColor,
} from "../js/toolsOptions";
import {
  changeToolColor,
  changeGlitterColor,
  setColorBox,
} from "../js/handlers";
import Draw from "../js/draw";

export default function ToolMenu({ colors, sizes }) {
  // this useEffect is for catching clicks outside tool menu, to close it;
  useEffect(() => {
    let pickMenu = document.querySelector(".pickMenuContainer");
    let botMenu = document.querySelector(".botMenuLeft");
    let pointerdown = Common.mobile ? "touchstart" : "mousedown";

    function mouseDownOutsideMenu(ev) {
      let clickedElement = ev.target;
      if (
        !pickMenu.contains(clickedElement) &&
        !botMenu.contains(clickedElement)
      ) {
        pickMenu.classList.remove("showPickMenu");
      }

      if (clickedElement.parentNode.classList.contains("close")) {
        pickMenu.classList.remove("showPickMenu");
      }
    }

    document.addEventListener(pointerdown, mouseDownOutsideMenu);

    return () => {
      document.removeEventListener(pointerdown, mouseDownOutsideMenu);
    };
  }, []);

  return (
    <div className="pickMenuContainer">
      <div className="pickMenuSecondBorder">
        <ToolSize sizes={sizes} />
        <ToolPath colors={colors} />
        <button className="close">
          <img src={close} alt="" />
        </button>
      </div>
    </div>
  );
}

function ToolSize({ sizes }) {
  let available = sizes === undefined ? false : true;

  useEffect(() => {
    let toolSize = document.querySelector(".toolSize");

    function sizeSelection(ev) {
      if (!ev.target.closest("BUTTON")) {
        return;
      }

      let button = ev.target.closest("BUTTON").dataset.size;
      let size = getSizeAndPath(Common.tool)[button];

      Common.width = size;

      let buttons = document.querySelectorAll(".toolSizeButton");

      for (let i = 0; i < buttons.length; i++) {
        buttons[i].firstElementChild.src = sizes[i];
      }

      ev.target.src = getSizesSelected(Common.tool)[button];
    }

    toolSize.addEventListener("click", sizeSelection);

    return () => {
      toolSize.removeEventListener("click", sizeSelection);
    };
  }, [sizes]);

  useEffect(() => {
    let toolSize = document.querySelector(".toolSize");
    let pencilImage = toolSize.firstElementChild.firstElementChild;

    pencilImage.src = getSizesSelected("pencil")[0];
  }, []);

  return (
    <div className={available ? "toolSize" : "toolSize toolSizeEmpty"}>
      {available ? (
        <>
          <button className="toolSizeButton" data-size="0">
            <img className="toolSizeImage" src={sizes[0]} alt="" />
          </button>
          <button className="toolSizeButton" data-size="1">
            <img className="toolSizeImage" src={sizes[1]} alt="" />
          </button>
          <button className="toolSizeButton" data-size="2">
            <img className="toolSizeImage" src={sizes[2]} alt="" />
          </button>
        </>
      ) : (
        ""
      )}
    </div>
  );
}

function ToolPath({ colors }) {
  useEffect(() => {
    let pickOptions = document.querySelector(".pickOptions");

    // return if eraser is picked. Since it doesn't have colors and "pickOptions" is null;
    if (!pickOptions) {
      return;
    }

    function colorSelection(ev) {
      let target = ev.target;
      let nodeName = target.nodeName;

      if (nodeName !== "SPAN" && nodeName !== "IMG") {
        return;
      }

      if (nodeName === "SPAN") {
        Common.selectedColor = target;
        Common.selectedGlitter = null;
      } else {
        Common.selectedGlitter = target.src;
        Common.selectedColor = null;
        Common.glitterID = target.dataset.path.substr(0, 8);
        Common.color = target.dataset.path.substr(9);
      }

      setColorBox();
    }

    pickOptions.addEventListener("click", colorSelection);

    // keep selected border on path, if same tool is clicked;
    if (Common.selectedColor || Common.selectedGlitter) {
      setColorBox();
    }

    return () => {
      pickOptions.removeEventListener("click", colorSelection);
    };
  });

  if (!colors) {
    return <div className="pickMenuEmpty"></div>;
  }

  let colorsLength = colors.length;
  let rowsNumber = Math.ceil(colorsLength / 9);
  let counter = 0;
  let rows = [];

  for (let i = 0; i < rowsNumber; i++) {
    let row = [];

    for (let j = 0; j < 9; j++) {
      if (rows.length === 0) {
        row.push(
          <img
            key={uuidv4()}
            data-path={`glitter${counter} ${glitterShadowColor[j]}`}
            onClick={changeGlitter}
            src={colors[counter]}
            alt=""
          />
        );
      } else {
        row.push(
          <span
            style={{ backgroundColor: colors[counter] }}
            key={uuidv4()}
            data-path={colors[counter]}
            onClick={changeColor}
          ></span>
        );
      }
      counter++;
    }

    rows.push(<div key={uuidv4()}>{[...row]}</div>);
  }

  function changeColor(ev) {
    Common.color = ev.target.dataset.path;
    Common.glitter = false;

    let down = Common.mobile ? "touchstart" : "mousedown";

    Common.main_canvas.removeEventListener(down, Draw.draw_glitter);
    Common.main_canvas.addEventListener(down, Draw.draw);

    changeToolColor();
  }

  function changeGlitter(ev) {
    Common.selectedGlitter = ev.target.src;
    Common.glitterImage = ev.target;
    Common.glitter = true;
    Draw.glitter_image.src = ev.target.src;

    let down = Common.mobile ? "touchstart" : "mousedown";

    Common.main_canvas.removeEventListener(down, Draw.draw);
    Common.main_canvas.addEventListener(down, Draw.draw_glitter);

    changeGlitterColor();
  }

  return (
    <div className="pickMenuWrapper">
      <div className="pickOptions">{rows}</div>
    </div>
  );
}
